import { render, staticRenderFns } from "./CompareCell.vue?vue&type=template&id=7b454afb&scoped=true&"
import script from "./CompareCell.vue?vue&type=script&lang=ts&"
export * from "./CompareCell.vue?vue&type=script&lang=ts&"
import style0 from "./CompareCell.vue?vue&type=style&index=0&id=7b454afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b454afb",
  null
  
)

export default component.exports